import React from "react";
import "./admin/BackendLayout.css";
import { Header, Sidebar, Footer } from "./admin";
import {Breadcrumb} from "../components";
import _ from "lodash";
import { useSelector } from "react-redux";
import LoadingSpinner from "../components/loading/LoadingSpinner";

const BackendLayout = (props) => {
  const { breadcrumb, children, page = "", showHeader = true } = props;
  const sidebar = useSelector((state) => state.page_settings.sidebar);
  let hasSidebar = _.isEmpty(sidebar) ? false : true;
  let hasBreadcrumb = _.isEmpty(breadcrumb) ? false : true;
  let container =
    page === "top" ? "w-full flex-none" : "page-content-container flex-none flex-grow";
  return (
    /* Page Container */
    <div className="w-full flex flex-col">
      {showHeader && <Header />}
      <div className="relative">
        <LoadingSpinner />
        <main id="view-main"
          className={`flex-none flex flex-row main-container overflow-x-auto ${
            showHeader ? "" : "!min-h-screen"
          }`}
        >
          {hasSidebar && <Sidebar sidebar={sidebar} />}
          <div className={`${container}  px-6 pt-2`}>
            {/* Content Container */}
            <div className="page-container">
              {hasBreadcrumb && <Breadcrumb breadcrumb={breadcrumb} />}
              {children}
            </div>
            <Footer />
          </div>
        </main>
      </div>
    </div> /* End Page Container */
  );
};

export default BackendLayout;
